import { render, staticRenderFns } from "./pejabat.vue?vue&type=template&id=c02a9e20&"
import script from "./pejabat.vue?vue&type=script&lang=js&"
export * from "./pejabat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports